export enum MoveMode {
    NodeAndChildren = "node-and-children",
    AllChildren = "all-children",
    AllChildrenAndDelete = "all-children-and-delete",
}
